import {SchemaValidationState, SchemaValidationStatus} from 'schemas/SchemaValidationConstants';

function isValidationState(
  status: string
): (schemaValidationState?: SchemaValidationState | null) => boolean {
  return function isGivenValidationState(schemaValidationState?: SchemaValidationState | null): boolean {
    return schemaValidationState != null && schemaValidationState.status === status;
  };
}

export const isFailed = isValidationState(SchemaValidationStatus.FAILED);
export const isOverridden = isValidationState(SchemaValidationStatus.OVERRIDDEN);
export const isValidating = isValidationState(SchemaValidationStatus.VALIDATING);
